<template>
  <div>
    <avue-form
      v-model="formData"
      ref="form"
      :option="formOption"
    ></avue-form>
    <div>
      <avue-crud ref="crud" :data="formData.trainListLineDetailList" :table-loading="loading" :option="tableOption">
        <template slot="menuLeft">
          <el-button
            type="primary"
            size="small"
            @click="handleAdd">
            新增
          </el-button>
        </template>
        <template slot="menu" slot-scope="scope">
          <el-popconfirm
            title="确定删除吗？"
            placement="top"
            cancel-button-type="default"
            @confirm="onDelete(scope)"
          >
            <el-button type="text" size="small" slot="reference">删除</el-button>
          </el-popconfirm>
        </template>
      </avue-crud>
    </div>
    <div class="avue-dialog__footer">
      <el-button icon="el-icon-circle-check" type="primary" :loading="loading" @click="handleOk">确 定</el-button>
      <el-button icon="el-icon-circle-close" @click="$emit('update:visible', false)">关 闭</el-button>
    </div>
  </div>
</template>
<script>
import RowEdit from "@/components/matrix/row-edit.vue";
import {postRequest} from "@/api/matrixApi";
import {getDate} from "@/util/date";

export default {
  components: {RowEdit},
  props: {
    visible: Boolean,
    totalCarriage: Number, // 总车数
    isHGZ: Boolean,
    carriageList: {type: Array, default: () => []} // 已有车厢列表
  },
  data() {
    return {
      loading: false,
      trainInfo: {},
      url: {
        trainUrl: '/check/train/trainList/artificialInput',
        carriageUrl: '/check/train/detailList/artificialInput',
      },
      formData: {
        trainListLineDetailList: []
      },
      baseTrainSerial: 1, // 车厢序号基数
      formOption: {
        menuBtn: false,
        span: 8,
        filterDic: true,
        column: [
          {
            label: "股道",
            prop: "poundno",
            type: "select",
            dicUrl: `${this.baseDicUrl}/${this.isHGZ ? 'hgz_poundno_code' : 'jtg_poundno_dx'}`,
            props: this.dicProps,
 filterable:true,
            value: this.isHGZ ? '001' : '002',
            clearable: false,
            rules: [
              {
                required: true,
                message: "请选择股道",
                trigger: "blur",
              }
            ]
          },
          {
            label: "过车时间",
            prop: "comeTime",
            type: "datetime",
            format:'yyyy-MM-dd HH:mm:ss',
            valueFormat:'yyyy-MM-dd HH:mm:ss',
            value: getDate(),
            clearable: false,
            pickerOptions: {
              // selectableRange:(()=>{
              //   let data=new Date();
              //   let hour=data.getHours();
              //   let minute=data.getMinutes();
              //   let second=data.getSeconds();
              //   return [`00:00:00 - ${hour}:${minute}:${second}`]
              // })(),
              disabledDate(time) {
                return time.getTime() > Date.now();
              },
            },
            rules: [
              {
                required: true,
                message: "请选择过车时间",
                trigger: "blur",
              }
            ]
          },
          {
            label: "方向",
            prop: "direction",
            type: "select",
            dicUrl: `${this.baseDicUrl}/direction`,
            props: this.dicProps,
 filterable:true,
            dataType: "number",
            value: 3,
            clearable: false,
            rules: [
              {
                required: true,
                message: "请选择方向",
                trigger: "blur",
              }
            ]
          },
        ]
      },
      tableOption: {
        index: false,
        selection: false,
        border: true,
        viewBtn: false,
        editBtn: false,
        addBtn: false,
        delBtn: false,
        columnBtn: false,
        refreshBtn: false,
        addRowBtn: false,
        indexFixed: false,
        selectionFixed: false,
        expandFixed: false,
        menuFixed: false,
        gridBtn: false,
        size: 'mini',
        labelSuffix: ' ', // label的后缀，这里是个空格，不是空字符串
        maxHeight: 300,
        menuWidth: 120,
        align: 'center',
        column: [
          {
            label: '车厢序号',
            prop: 'trainSerial',
            width: 80,
            cell: true,
            disabled: true,
          },
          {
            label: '车型',
            prop: 'trainType',
            cell: true,
            maxlength: 8,
            rules: [
              this.getInputRules('numEn')
            ],
            change: ({row, value}) => {
              row.trainType = value.toUpperCase()
            }
          },
          {
            label: '车号',
            prop: 'trainNo',
            cell: true,
            maxlength: 16,
            rules: [
              this.getInputRules('onlyNum')
            ]
          },
          {
            label: '标重(T)',
            prop: 'trainLoad',
            cell: true,
            maxlength: 5,
            rules: [
              this.getInputRules('isIntegerDecimal')
            ]
          },
          {
            label: '自重(T)',
            prop: 'trainSelf',
            cell: true,
            maxlength: 5,
            rules: [
              this.getInputRules('isIntegerDecimal')
            ]
          },
          {
            label: '集装箱1',
            prop: 'containerNo1',
            cell: true,
            maxlength: 16,
            rules: [
              this.getInputRules('numEn')
            ],
            change: ({row, value}) => {
              row.containerNo1 = value.toUpperCase()
            }
          },
          {
            label: '集装箱2',
            prop: 'containerNo2',
            cell: true,
            maxlength: 16,
            rules: [
              this.getInputRules('numEn')
            ],
            change: ({row, value}) => {
              row.containerNo2 = value.toUpperCase()
            }
          }
        ],
      }
    }
  },
  mounted() {

  },
  methods: {
    initForm(trainInfo) {
      // 有 trainInfo 车厢新增
      if (trainInfo) {
        this.trainInfo = trainInfo
        const {poundno, comeTime, direction} = trainInfo
        this.formData = {poundno, comeTime, direction, trainListLineDetailList: []}
        // 车厢序号基数 = 已有车厢最后一节车厢序号 + 1
        const lastSerial = this.carriageList[this.carriageList.length - 1].trainSerial
        this.baseTrainSerial = Number(lastSerial) + 1
        this.$refs.form.allDisabled = true
      }
      setTimeout(() =>{
        this.handleAdd()
      }, 100)
    },
    // 新增行
    handleAdd() {
      this.$refs.crud.rowCellAdd({trainSerial: this.formData.trainListLineDetailList.length + this.baseTrainSerial})
    },
    // 删除行
    onDelete(scope) {
      const arr = this.deepClone(this.formData.trainListLineDetailList)
      arr.splice(scope.index, 1)
      // 删除车厢序号重新排序
      this.formData.trainListLineDetailList = arr.map((item, idx) => ({...item, trainSerial: idx + this.baseTrainSerial}))
    },
    handleOk() {
      if (!this.formData.trainListLineDetailList || !this.formData.trainListLineDetailList.length) {
        return this.$message.error('表格数据不得为空')
      }
      this.$refs.form.validate((valid, done) => { // 主表校验
        if (valid) {
          this.$refs.crud.$refs.cellForm.validate((validC) => { // 子表校验
            if (validC) {
              // 车号、集装箱1 不能同时为空
              const isNull = this.formData.trainListLineDetailList.some((item, idx) => {
                if (!item.trainNo && !item.containerNo1) {
                  this.$message.error(`车厢序号${idx + 1},车号、集装箱号不能同时为空`)
                  return true
                }
              })
              if (!isNull) {
                this.handleSubmit(done)
              } else {
                done()
              }
            } else {
              this.$message.error('错误, 请验证子表必填项并录入符合规则的数据')
            }
          })
        }
      })
    },
    // 提交
    handleSubmit(done) {
      this.loading = true
      let submitUrl = this.url.trainUrl
      let params = {}
      if (this.trainInfo.id) { // 车厢录入
        submitUrl = this.url.carriageUrl
        params.detailList = this.formData.trainListLineDetailList
        params.id = this.trainInfo.id
      } else {// 车次录入
        params = this.deepClone(this.formData)
        params.detailList = params.trainListLineDetailList
        delete params.trainListLineDetailList
      }
      postRequest(submitUrl, params).then(res => {
        if (res.code === 200) {
          this.$message.success('操作成功')
          this.$emit('afterSubmit', this.trainInfo.id)
          this.$emit('update:visible', false)
        }
      }).finally(() => {
        this.loading = false
        if (done) done()
      })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-table tbody .cell {
  padding-top: 4px;
  height: 36px;
}
</style>
